module.exports = __webpack_public_path__ + "img/ValueClose.87b534a1.png";